import Image from "next/image"
import React from "react"

interface LogoH5Props {
  width?: number | string
  height?: number | string
  className?: string
}

/**
 * SMM Logo H5 组件
 * 直接在组件内部定义 SVG，无需外部文件
 */
const LogoH5: React.FC<LogoH5Props> = ({ width = 80, height = 33, className }) => {
  return (
    <Image
      src={`https://imgqn.smm.cn/static/image/metal/logo.svg`}
      alt="logo"
      width={Number(width)}
      height={Number(height)}
      unoptimized
      className={className}
    />
  )
}

export { LogoH5 }
